import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { isMobile, isAndroid } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import api from '../../services/api';

import './styles.css';

import logo from '../../assests/logo-transparent.png';
import fotoAgro from '../../assests/login-hero.png';

let parar = 0;

if (isMobile) {
  if (isAndroid) {
    parar++;
    window.location.href = "https://play.google.com/store/apps/details?id=br.com.agrobrazil";
    //window.location.href = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=br.com.agrobrazil&ddl=1&pcampaignid=web_ddl_1";
  } else {
    parar++;
    window.location.href = "https://apps.apple.com/br/app/agrobrazil/id1445596318";
  }

}

export default function Logon() {
  const { t } = useTranslation();
  const params = window.location.search.substring(1).split('&');
  const url = window.location.search;
  const vUrl = url.split("/");
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  sessionStorage.setItem('BASE_URL', 'https://agrobrazilapp.com');
  //sessionStorage.setItem('BASE_URL', 'https://agrobrazilapp.com');

  checkLogin(params, url, vUrl);

  function checkLogin(params, url, vUrl) {
    console.log(params);
    console.log(url);
    console.log(vUrl);
    if (url === '?recuperar') {
      sessionStorage.setItem('id', "");
      sessionStorage.setItem('name', "");
      sessionStorage.setItem('token', "");
      sessionStorage.setItem('email', "");
      sessionStorage.setItem('hashTag', '');
      history.push('/recuperar');
      return false;
    } else if (url === '?register') {
      sessionStorage.setItem('id', "");
      sessionStorage.setItem('name', "");
      sessionStorage.setItem('token', "");
      sessionStorage.setItem('email', "");
      sessionStorage.setItem('hashTag', '');
      history.push('/register');
      return false;
    } else if (url === '?negociacoes') {
      // sessionStorage.setItem('id', sessionStorage.getItem('id2'));
      // sessionStorage.setItem('name', sessionStorage.getItem('nome2'));
      // //sessionStorage.setItem('token', sessionStorage.getItem('token2'));
      // sessionStorage.setItem('email', sessionStorage.getItem('email2'));
      // sessionStorage.setItem('hashTag', sessionStorage.getItem('hashTag2'));
      history.push('/negociacoes');
      return false;
    } else if (vUrl[1] === 'informacao') {
      // sessionStorage.setItem('id', sessionStorage.getItem('id2'));
      // sessionStorage.setItem('name', sessionStorage.getItem('nome2'));
      // //sessionStorage.setItem('token', sessionStorage.getItem('token2'));
      // sessionStorage.setItem('email', sessionStorage.getItem('email2'));
      // sessionStorage.setItem('hashTag', sessionStorage.getItem('hashTag2'));
      //console.log('/' + vUrl[0].replace("?", "") + '/' + vUrl[1] + '/' + vUrl[2]);
      history.push('/' + vUrl[0].replace("?", "") + '/' + vUrl[1] + '/' + vUrl[2]);
      return false;
    } else {


      if (params.length > 4) {
        history.push('/login?' + url);
      }
    }
  }




  // const [token, setToken] = useState('');


  async function pegarDados() {
    await api.get(`/v4/users/me`, {
      headers: {
        'USER_EMAIL': sessionStorage.getItem('email'),
        'USER_TOKEN': sessionStorage.getItem('token'),
      }
    }).then(response => {
      sessionStorage.setItem('phone', response.data.phone);
      sessionStorage.setItem('tags', JSON.stringify(response.data.interested_tags));
      sessionStorage.setItem('plan', JSON.stringify(response.data.plan));
      //(response.data)
    });
  }

  async function handleLogin(e) {
    e.preventDefault();
    try {

      const response = await api.post('/v4/users/sign_in', { email, password });
      sessionStorage.setItem('id', response.data.id);
      sessionStorage.setItem('name', response.data.name);
      sessionStorage.setItem('token', response.data.token);
      sessionStorage.setItem('email', response.data.email);
      sessionStorage.setItem('nickname', response.data.nickname);
      sessionStorage.setItem('avatar', JSON.stringify(response.data.avatar));

      //pegarDados();

      api.get(`/v4/users/me`, {
        headers: {
          'USER_EMAIL': sessionStorage.getItem('email'),
          'USER_TOKEN': sessionStorage.getItem('token'),
        }
      }).then(response => {
        sessionStorage.setItem('phone', response.data.phone);
        sessionStorage.setItem('tags', JSON.stringify(response.data.interested_tags));
        sessionStorage.setItem('plan', JSON.stringify(response.data.plan));
      });

      history.push('/timeline');

    } catch (err) {
      alert(t('pages.logon.errorLogin'));
    }
  }
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');

  async function pegarDados() {
    await api.get(`/v4/users/me`, {
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
      }
    }).then(response => {
      sessionStorage.setItem('phone', response.data.phone);
      sessionStorage.setItem('tags', JSON.stringify(response.data.interested_tags));
      sessionStorage.setItem('plan', JSON.stringify(response.data.plan));
    });
  }
  if (isMobile) {
    return (
      <div className="logon-container">
        <section className="form">
          <h1>
            {t('pages.logon.mobileInfo')}
          </h1>
        </section>

      </div>
    )
  } else {
    return (
      <div className="logon-container">
        <section className="form">
          <div className="logon-card">
            <img className="logo" src={logo} alt={t('commons.alt.agroPicture')} />
            <form onSubmit={handleLogin}>
              <h1>{t('pages.logon.info')}</h1>
              <label>
                {t('pages.logon.placeholder.email')}
                <input
                  type="email"
                  placeholder={t('pages.logon.placeholder.email')}
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </label>
              <label>
                {t('pages.logon.placeholder.password')}
                <input
                  type="password"
                  placeholder={t('pages.logon.placeholder.password')}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
              </label>
              <button className="logon-enter" type="submit">{t('pages.logon.buttons.login')}</button>
              <Link to="/register" className="logon-register">{t('pages.logon.buttons.register')}</Link>
              <a className="logon-forgot" href="/?recuperar">{t('pages.logon.buttons.forgetPassword')}</a>
            </form>
          </div>
        </section>
        <div className="logon-hero">
          <img src={fotoAgro} alt={t('commons.alt.agroPicture')} />
        </div>
      </div>
    );
  }
}
